import React, { useState } from "react";
import { CreateComponentProps } from "./CreateDashboardComponentTab";
import { Button, Input, Select, TextArea } from "@aidkitorg/component-library";
import { AGGREGATION_OPTIONS, getAggregationOption } from "./MetricComponentConfig";
import { BarChart, SummaryExpr } from "@aidkitorg/types/lib/survey";
import { useDashboards } from "../../../Contexts/DashboardsContext";
import { generateDistroSummaryKind } from "../../../utils/adminPanel.utils";

export const BarChartComponentConfig: React.FC<CreateComponentProps> = ({ setDisplayMode }) => {
  const [title, setTitle] = useState('')
  const [description, setDescription] = useState('')
  
  const [xAxis, setXAxis] = useState<{
    title: string,
    dataField: string
  }>(
    {title: '', dataField: ''}
  )
  const [yAxis, setYAxis] = useState<{
    title: string,
    aggregation: string,
    dataField: string
  }>({
    title: '',
    aggregation: 'Count',
    dataField: ''
  })

  const {
    setStagedComponents,
  } = useDashboards()

  const saveBarChartComponent = async () => {
    const barChartToStage: BarChart = {
      kind: 'Bar Chart',
      title: title,
      summary: generateDistroSummaryKind(yAxis.aggregation, yAxis.dataField),
      groups: [{
        kind: 'Field',
        field: xAxis.dataField
      }]
    }

    setStagedComponents((prev) => ([...prev, barChartToStage]))
  }

  const isSaveDisabled = title === '' || 
    xAxis.title === '' || 
    xAxis.dataField == '' ||
    yAxis.title === '' ||
    (yAxis.aggregation !== 'Count' && yAxis.dataField === '')

  return (
    <div className="flex flex-col gap-y-2">
      <div className="font-medium text-lg">
        Add Bar Chart
      </div>

      <Input 
        required
        label="Chart Title"
        value={title}
        onChange={(e) => setTitle(e.target.value)}
      />

      <Input 
        required
        placeholder="Display label"
        label="Category/Dimension (X-Axis)"
        value={xAxis.title}
        onChange={(e) => setXAxis({...xAxis, title: e.target.value})}
      />
      <Input
        required
        placeholder="Data field"
        label="Category/Dimension Data Field"
        showLabel={false}
        value={xAxis.dataField}
        onChange={(e) => setXAxis({...xAxis, dataField: e.target.value})}
      />

      <Input
        required
        label="Measures (Y-Axis)"
        placeholder="Metric Label"
        value={yAxis.title}
        onChange={(e) => setYAxis({...yAxis, title: e.target.value})}
      />
      <Select
        // TODO: add required
        options={AGGREGATION_OPTIONS}
        label="Aggregation"
        description="Aggregation done for this metric"
        labelLocation="inline"
        value={getAggregationOption(yAxis.aggregation)}
        onChange={(value) => setYAxis({...yAxis, aggregation: value.value})}
      />
      {yAxis.aggregation !== 'Count' && (
        <Input
          placeholder="Data field"
          label="Y-Axis Data Field"
          showLabel={false}
          required
          value={yAxis.dataField}
          onChange={(e) => setYAxis({...yAxis, dataField: e.target.value})}
        />
      )}
    
      <TextArea
        label="Description"
        showLabel
        value={description}
        onChange={(e) => setDescription(e.target.value)}
      />

      <div className="flex justify-between gap-x-2 pt-2">
        <Button onClick={() => setDisplayMode('create')} className="!w-1/2" variant="secondary">Cancel</Button>
        <Button isDisabled={isSaveDisabled} onClick={saveBarChartComponent} className="!w-1/2">Save</Button>
      </div>
    </div>
  )
}